<template>
  <div class="submissions-filters">
    <div class="d-flex align-center flex-wrap mb-4 filter-toolbar">
      <v-spacer />

      <v-chip
        v-for="chip in activeFilterChips"
        :key="chip.key"
        small
        outlined
        close
        class="mr-2 mt-1"
        @click:close="clearFilter(chip.key)"
      >
        {{ chip.label }}
      </v-chip>

      <v-chip
        v-if="hasActiveFilters"
        small
        color="primary"
        text-color="white"
        class="mr-2"
      >
        {{ activeFiltersCount }} فلتر نشط
      </v-chip>

      <v-btn color="primary" outlined class="filter-btn" @click="openDialog">
        <v-icon left>mdi-filter-variant</v-icon>
        تصفية
      </v-btn>
    </div>

    <v-dialog v-model="dialog" max-width="560" persistent>
      <v-card>
        <v-card-title class="headline primary white--text">
          تصفية الطلبات
          <v-spacer />
          <v-btn icon dark @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pt-5">
          <v-text-field
            v-model="localFilters.q"
            label="بحث بالاسم أو الجوال أو البريد"
            placeholder="بحث بالاسم أو الجوال أو البريد"
            prepend-inner-icon="mdi-magnify"
            outlined
            dense
            clearable
            class="mb-3"
            @keyup.enter="apply"
          />

          <v-text-field
            v-model="localFilters.mobile"
            label="رقم الجوال"
            placeholder="رقم الجوال"
            outlined
            dense
            clearable
            class="mb-3"
            @keyup.enter="apply"
          />

          <v-row dense class="mb-3">
            <v-col cols="12" sm="6">
              <PickerInput
                :key="`date-from-${pickerResetKey}`"
                label="تاريخ الإرسال من"
                @dateValue="onDateFrom"
              />
            </v-col>
            <v-col cols="12" sm="6">
              <PickerInput
                :key="`date-to-${pickerResetKey}`"
                label="تاريخ الإرسال إلى"
                @dateValue="onDateTo"
              />
            </v-col>
          </v-row>

          <v-select
            v-model="localPerPage"
            :items="perPageOptions"
            label="عدد الصفوف"
            outlined
            dense
          />
        </v-card-text>

        <v-card-actions class="px-4 pb-4">
          <v-btn text color="error" @click="reset">
            <v-icon left small>mdi-refresh</v-icon>
            إعادة تعيين
          </v-btn>
          <v-spacer />
          <v-btn text @click="closeDialog">إلغاء</v-btn>
          <v-btn color="primary" @click="apply">
            <v-icon left small>mdi-magnify</v-icon>
            بحث
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import PickerInput from "@/components/AdminComponent/PickerInput.vue";

export default {
  name: "SubmissionsFilters",
  components: { PickerInput },
  props: {
    filters: {
      type: Object,
      required: true,
    },
    perPage: {
      type: Number,
      default: 10,
    },
  },
  data() {
    return {
      dialog: false,
      localFilters: { ...this.filters },
      localPerPage: this.perPage,
      perPageOptions: [10, 25, 50],
      pickerResetKey: 0,
    };
  },
  computed: {
    hasActiveFilters() {
      return this.activeFiltersCount > 0;
    },
    activeFiltersCount() {
      let count = 0;
      if (this.filters.q) count += 1;
      if (this.filters.mobile) count += 1;
      if (this.filters.date_from) count += 1;
      if (this.filters.date_to) count += 1;
      return count;
    },
    activeFilterChips() {
      const chips = [];

      if (this.filters.q) {
        chips.push({ key: "q", label: `بحث: ${this.filters.q}` });
      }
      if (this.filters.mobile) {
        chips.push({ key: "mobile", label: `جوال: ${this.filters.mobile}` });
      }
      if (this.filters.date_from) {
        chips.push({ key: "date_from", label: `من: ${this.filters.date_from}` });
      }
      if (this.filters.date_to) {
        chips.push({ key: "date_to", label: `إلى: ${this.filters.date_to}` });
      }

      return chips;
    },
  },
  watch: {
    filters: {
      deep: true,
      handler(val) {
        if (!this.dialog) {
          this.localFilters = { ...val };
        }
      },
    },
    perPage(val) {
      if (!this.dialog) {
        this.localPerPage = val;
      }
    },
  },
  methods: {
    onDateFrom(val) {
      this.localFilters.date_from = val || "";
    },
    onDateTo(val) {
      this.localFilters.date_to = val || "";
    },
    openDialog() {
      this.localFilters = { ...this.filters };
      this.localPerPage = this.perPage;
      this.pickerResetKey += 1;
      this.dialog = true;
    },
    closeDialog() {
      this.localFilters = { ...this.filters };
      this.localPerPage = this.perPage;
      this.pickerResetKey += 1;
      this.dialog = false;
    },
    apply() {
      this.$emit("update:filters", { ...this.localFilters });
      this.$emit("update:perPage", this.localPerPage);
      this.$emit("search");
      this.dialog = false;
    },
    reset() {
      this.localFilters = { q: "", mobile: "", date_from: "", date_to: "" };
      this.localPerPage = 10;
      this.pickerResetKey += 1;
      this.$emit("update:filters", { ...this.localFilters });
      this.$emit("update:perPage", this.localPerPage);
      this.$emit("reset");
      this.dialog = false;
    },
    clearFilter(key) {
      const nextFilters = { ...this.filters, [key]: "" };
      this.$emit("update:filters", nextFilters);
      this.$emit("search");
    },
  },
};
</script>

<style scoped>
.filter-toolbar {
  width: 100%;
}
</style>
